import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const JimProfile = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/creators', { replace: true });
  }, [navigate]);

  return null;
};

export default JimProfile;
